import { render, staticRenderFns } from "./stockByCustomer.vue?vue&type=template&id=6cb432cb&scoped=true&"
import script from "./stockByCustomer.vue?vue&type=script&lang=js&"
export * from "./stockByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./stockByCustomer.vue?vue&type=style&index=0&id=6cb432cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb432cb",
  null
  
)

export default component.exports